import { Edge, Node } from 'reactflow';
import { getSourceHandleIDS, getTargetHandleID } from './get-handle-ids';

export function getRelatedEdges(edges: Array<Edge>, nodes: Array<Node>): Array<Edge> {
  const sources = nodes.reduce((acc: Array<string>, node) => acc.concat(getSourceHandleIDS(node)), []);
  const target = nodes.map(getTargetHandleID);

  return edges.filter((edge) => sources.includes(edge.sourceHandle as string) || target.includes(edge.target));
}
